<template>
  <div class="top">
    <div class="top-left" style="float: left">
      <Button type="ghost" icon="ios-undo" @click="back">返回</Button>
    </div>
    <div class="top-right" style="float: right; padding: 0 5px 0">
      <!-- <Button
        type="primary"
        class="search-button"
        style="margin-left: 10px"
        @click="usedanalyse"
        >用户分析</Button
      > -->
      <Button
        type="primary"
        class="search-button"
        style="margin-left: 10px"
        @click="smartPhone"
      >
        智能电话
      </Button>
      <Button
        type="primary"
        class="search-button"
        style="margin-left: 10px"
        @click="editBtn('编辑联系人', 'editModal')"
      >
        编辑联系人
      </Button>
      <!-- <Button
        v-if="user.isMain == 1 && user.sysrole == 1"
        type="primary"
        class="search-button"
        style="margin-left: 10px"
        @click="editBtn('分配客服', 'distriServeModal')"
        >分配客服</Button
      >
      <Button
        v-if="user.isMain == 1 && user.sysrole == 1"
        type="primary"
        class="search-button"
        style="margin-left: 10px"
        @click="editBtn('短信充值', 'sMessageModal')"
        >短信充值</Button
      >
      <Button
        v-if="user.isMain == 1 && user.sysrole == 1"
        type="primary"
        class="search-button"
        style="margin-left: 10px"
        @click="editBtn('模板数更改', 'templateModal')"
        >模板数更改</Button
      >-->
      <Button
        type="primary"
        class="search-button"
        style="margin-left: 5px"
        @click="editBtn('新增跟进记录', 'followUpRecModal')"
      >
        新增跟进记录
      </Button>
      <Button
        type="primary"
        class="search-button"
        style="margin-left: 5px"
        @click="editBtn('企业跟进提醒', 'followupremindModal')"
      >
        企业跟进提醒
      </Button>
      <Button
        v-if="user.isMain == 1 && user.sysrole == 1"
        type="primary"
        class="search-button"
        style="margin-left: 5px"
        @click="editBtn('开通项目管理', 'OpentheProject')"
      >
        开通项目管理
      </Button>
      <Button
        v-if="user.isMain == 1 && user.sysrole == 1"
        type="primary"
        class="search-button"
        style="margin-left: 5px"
        @click="editBtn('开通开放平台', 'Opentheplatform')"
      >
        开通开放平台
      </Button>
      <Dropdown
        placement="bottom-end"
        trigger="click"
        style="margin-left: 5px"
        @on-click="moreClick"
      >
        <Button type="primary" class="search-button">
          更多
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list" trigger="click">
          <DropdownItem name="usedanalyse">用户分析</DropdownItem>
          <!-- <DropdownItem name="smartPhone">智能电话</DropdownItem> -->
          <!-- <DropdownItem name="editModal">编辑联系人</DropdownItem> -->
          <DropdownItem
            v-if="user.isMain == 1 && user.sysrole == 1"
            name="distriServeModal"
          >
            分配客服
          </DropdownItem>
          <DropdownItem
            v-if="user.isMain == 1 && user.sysrole == 1"
            name="sMessageModal"
          >
            短信充值
          </DropdownItem>
          <DropdownItem
            v-if="user.isMain == 1 && user.sysrole == 1"
            name="templateModal"
          >
            模板数更改
          </DropdownItem>
          <DropdownItem
            v-if="user.isMain == 1 && user.sysrole == 1"
            name="distriServeModal1"
          >
            新增机器人
          </DropdownItem>
          <DropdownItem v-if="user.sysrole == 1" name="allLableModal">
            编辑标签
          </DropdownItem>
          <!-- <DropdownItem name="followUpRecModal">新增跟进记录</DropdownItem>-->
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--编辑联系人-->
    <EditContact
      :agentId="agentId"
      :editModal="editModal"
      :editTitle="editTitle"
      :editRow="editRow"
      @callback="callback"
      @backeditModal="editModal = false"
    />
    <!--模板数更改-->
    <TemplateNumberChange
      :agentId="agentId"
      :templateModal="templateModal"
      :templateTitle="editTitle"
      :templateRow="editRow"
      @callback="callback"
      @backeditModal="templateModal = false"
    />
    <!--分配客服-->
    <DistriCustomerService
      :agentId="agentId"
      :distriServeModal="distriServeModal"
      :distriServeTitle="editTitle"
      :distriServeRow="editRow"
      @callback="callback"
      @backeditModal="distriServeModal = false"
    />
    <!--短信充值-->
    <ShortMessageRecharge
      :agentId="agentId"
      :sMessageModal="sMessageModal"
      :sMessageTitle="editTitle"
      :sMessageRow="editRow"
      @callback="callback"
      @backeditModal="sMessageModal = false"
    />
    <!--新增跟进记录-->
    <NewFollowUpRecords
      :agentId="agentId"
      :followUpRecModal="followUpRecModal"
      :followUpRecTitle="editTitle"
      :followUpRecRow="editRow"
      @callback="recordCallback"
      @backeditModal="followUpRecModal = false"
    />

    <!-- 企业跟进提醒 -->
    <FollowupremindModals
      :agentId="agentId"
      :followUpRecModal="followupremindModal"
      :followUpRecTitle="editTitle"
      :followUpRecRow="editRow"
      @backeditModal="followupremindModal = false"
    />

    <!-- 用户分析 -->
    <AddModal v-model="isShow" :form="temp" @callback="init" />

    <!-- 开通项目管理 -->
    <OpentheProjects
      :agentId="agentId"
      :OpentheProjectsModal="OpentheProject"
      :ProjectsTitle="editTitle"
      :ProjectsRow="editRow"
      @backeditModal="OpentheProject = false"
    />
    <!-- 开通开放平台 -->
    <Opentheplatforms
      :agentId="agentId"
      :platformUpRecModal="Opentheplatform"
      :platformUpRecTitle="editTitle"
      :platformUpRecRow="editRow"
      @backeditModal="Opentheplatform = false"
    />
    <!-- 新增机器人 -->
    <RobotSettings
      :distriServeModal="distriServeModal1"
      distriServeTitle="新增机器人"
      :epIds="editRow.id"
      @callback="callback"
      @backeditModal="distriServeModal1 = false"
    />
    <!--标签-->
    <AllLable1
      attached
      :distriServeTitle="'编辑标签'"
      v-model="allLableModal"
      :sparepart="editRow"
      @on-success="LabelItem"
    />
    <!-- 存储数量 -->
    <StorageModal
      :agentId="agentId"
      :storageModal="storageModal"
      :storageTitle="editTitle"
      :storageRow="editRow"
      @callback="callback"
      @backeditModal="storageModal = false"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EditContact from '../EditContact'
import TemplateNumberChange from '../TemplateNumberChange'
import DistriCustomerService from '../DistriCustomerService'
import ShortMessageRecharge from '../ShortMessageRecharge'
import StorageModal from '../StorageModal'
import NewFollowUpRecords from '../NewFollowUpRecords'
import FollowupremindModals from '../FollowupremindModals'
import OpentheProjects from '../OpentheProjects'
import Opentheplatforms from '../Opentheplatforms'
import AddModal from '../../../EnterpriseAnalyzeList/Modal/AddModal'
import RobotSettings from '../RobotSettings'
import AllLable1 from '../AllLable1'
export default {
  components: {
    EditContact,
    TemplateNumberChange,
    DistriCustomerService,
    ShortMessageRecharge,
    NewFollowUpRecords,
    FollowupremindModals,
    OpentheProjects,
    Opentheplatforms,
    AddModal,
    RobotSettings,
    AllLable1,
    StorageModal,
  },
  props: {
    followDetail: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      agentId: 1,
      editTitle: '编辑联系人',
      editRow: {},
      editModal: false,
      templateModal: false,
      distriServeModal: false,
      distriServeModal1: false,
      allLableModal: false,
      sMessageModal: false,
      followUpRecModal: false,
      followupremindModal: false,
      OpentheProject: false,
      Opentheplatform: false,
      isShow: false,
      storageModal: false,
      temp: {},
    }
  },
  computed: {
    ...mapState('user', ['user']),
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$http
        .get('/enterprise/analyze/detail', {
          params: {
            id: this.$route.params.orderId,
          },
        })
        .then((res) => {
          this.temp = res.data
        })
    },
    smartPhone() {
      let url = '/enterprise/mgr/call'
      let data = {
        epId: this.followDetail.id,
      }
      this.$http.post(url, data).then((res) => {
        if (res.success) {
          let msg = '拨打成功'
          this.$Message.success(msg)
          this.loadList()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    editBtn(title, model) {
      this.editTitle = title
      this.agentId = this.followDetail.id
      this.editRow = this.followDetail
      this[model] = true
    },
    back() {
      this.$router.back()
    },
    callback() {
      this.$emit('callback')
    },
    recordCallback() {
      this.$emit('recordCallback')
    },
    usedanalyse() {
      this.isShow = true
    },
    // 导出列表数据
    moreClick(name) {
      if (name === 'usedanalyse') {
        this.usedanalyse()
      }
      // if (name === 'smartPhone') {
      //   this.smartPhone()
      // }
      // if (name === 'editModal') {
      //   this.editBtn('编辑联系人', 'editModal')
      // }
      if (name === 'distriServeModal') {
        this.editBtn('分配客服', 'distriServeModal')
      }
      if (name === 'sMessageModal') {
        this.editBtn('短信充值', 'sMessageModal')
      }
      if (name === 'templateModal') {
        this.editBtn('模板数更改', 'templateModal')
      }
      if (name === 'distriServeModal1') {
        this.editBtn('新增机器人', 'distriServeModal1')
      }
      if (name === 'allLableModal') {
        this.editBtn('新增标签', 'allLableModal')
      }
    },
    // 回调
    LabelItem(row) {
      let url = '/label/edit/obj'
      let data = {
        type: '1',
        labelIds: row.map((v) => v.id),
        objectId: this.agentId,
      }
      this.$http.post(url, data).then((res) => {
        if (res.success) {
          let msg = '修改成功'
          this.$Message.success(msg)
          this.distriServeListModal = false
          this.callback()
        } else {
          this.$Message.error(res.message)
        }
        this.agentId = -1
      })
    },
  },
}
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetailTop.vue